import React from "react";
import Fab from "@mui/material/Fab";
import { ThemeProvider, Typography, createTheme } from "@mui/material";
import Vector from "../Images/ErrorArrow.svg";
import Vector1 from "../Images/GreenPlusSign.png";

// const theme= createTheme({
//   components:{
//     Fab:{
//     variants:[
//       {
//         props:{
//           variant: "extended"
//         },
//         style:{
//           height: "5px"
//         }
//       }
//     ]
//     }
//   }
// })

const Pill = ({
  noOfCases = 0,
  create = false,
  caseType,
  onClick = () => {},
}) => {
  return (
    <>
      {create
        ? CreatePill(noOfCases, caseType, onClick)
        : NormalPill(noOfCases, caseType, onClick)}
    </>
  );
};

const pillFab = {
  backgroundColor: "white",
  border: "0.05rem solid red",
  boxShadow: "none",
  height: "3rem",
  zIndex: 0,
};
const pillFabForCreateCase = {
  backgroundColor: "white",
  border: "0.05rem solid #59CE8F",
  boxShadow: "none",
  height: "3rem",
  zIndex: 0,
};

const pillTypographyForNoOfCases = {
  fontSize: "1.7rem",
  fontWeight: "700",
  paddingLeft: "0.5rem",
  // paddingRight: "0.3rem",
  paddingTop: "0px",
  paddingBottom: "0px",
};

const pillTypographyTypeOfCases = {
  fontWeight: "500",
  fontSize: "1.4rem",
  lineHeight: "1.4rem",
  paddingLeft: "0.6rem",
  paddingRight: "2rem",
  textTransform: "capitalize",
};
const NormalPill = (noOfCases, caseType, onClick) => {
  return (
    <>
      <Fab
        variant="extended"
        size="small"
        aria-label="add"
        sx={pillFab}
        onClick={onClick}
        id={caseType}
      >
        <Typography sx={pillTypographyForNoOfCases}>{noOfCases}</Typography>{" "}
        <Typography sx={pillTypographyTypeOfCases}>{caseType}</Typography>
        <img src={Vector} alt="arrow_img" />
      </Fab>
    </>
  );
};

const CreatePill = (noOfCases, caseType, onClick) => {
  return (
    <>
      <Fab
        variant="extended"
        size="small"
        aria-label="add"
        sx={pillFabForCreateCase}
        onClick={onClick}
      >
        <Typography sx={pillTypographyTypeOfCases}>Create Case</Typography>
        <img src={Vector1} alt="arrow_img" />
      </Fab>
    </>
  );
};

export default Pill;
